import React, { useState, useEffect } from "react";
import "./styles.css";
import "./PhoneInput.css";

const countries = [
    // { code: "+1", name: "USA", flag: "🇺🇸" },
    // { code: "+44", name: "UK", flag: "🇬🇧" },
    // { code: "+91", name: "India", flag: "🇮🇳" },
    { code: "+998", name: "Uzbekistan", flag: "🇺🇿" },
];

// id, autoComplete — faqat input atributlari (label bog'lash va brauzer avtomatik to'ldirishini boshqarish uchun).
const PhoneNumberForm = ({ phoneNumber, onChange, reset, id, autoComplete }) => {
    const [selectedCountry, setSelectedCountry] = useState(countries[0]);
    const [localPhone, setLocalPhone] = useState("");

    const handleCountryChange = (e) => {
        const country = countries.find((c) => c.code === e.target.value);
        setSelectedCountry(country);
        onChange(country.code + localPhone);
    };

    const handlePhoneChange = (e) => {
        const value = e.target.value.replace(/\D/g, ""); // Faqat raqamlar
        setLocalPhone(value);
        onChange(selectedCountry.code + value);
    };

    // 🔄 Reset funksiyasi
    useEffect(() => {
        if (reset) {
            setSelectedCountry(countries[0]);
            setLocalPhone("");
        }
    }, [reset]);

    return (
        <div className="ui-phone">
            <select
                className="ui-phone__country"
                value={selectedCountry.code}
                onChange={handleCountryChange}
                aria-label="Davlat kodi"
            >
                {countries.map((country) => (
                    <option key={country.code} value={country.code}>
                        {country.flag} {country.code}
                    </option>
                ))}
            </select>
            <input
                required
                type="text"
                value={localPhone}
                onChange={handlePhoneChange}
                placeholder="90 123 45 67"
                className="ui-phone__input"
                id={id}
                autoComplete={autoComplete}
                inputMode="numeric"
            />
        </div>
    );
};

export default PhoneNumberForm;
